import type { ReactNode } from 'react'

export function SectionHeader({
  title,
  description,
  action,
}: {
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="space-y-0.5">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-text-dim">{title}</h2>
        {action}
      </div>
      {description && <p className="text-[11px] text-text-dim/80 leading-snug">{description}</p>}
    </div>
  )
}
